import { render, staticRenderFns } from "./closeIcon.vue?vue&type=template&id=745f1b9e&scoped=true"
import script from "./closeIcon.vue?vue&type=script&lang=js"
export * from "./closeIcon.vue?vue&type=script&lang=js"
import style0 from "./closeIcon.vue?vue&type=style&index=0&id=745f1b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745f1b9e",
  null
  
)

export default component.exports